module.exports = __webpack_public_path__ + "static/media/slider_especialistas_icon7.cf46012e.svg";